export type UsagePlan = 'Free' | 'Paid';

export const UsagePlanLabel: Record<UsagePlan, string> = {
  Free: '無料プラン',
  Paid: '有料プラン'
};
